const isDate = (d) => d instanceof Date;

export default isDate;
